import { useMemo } from "react";
import { formatCallDuration } from "../../customers/callRecordings/duration";
import dayjs, { DATE_FORMAT } from "../../dayjs";
import type { AdminAgentPhoneCallResponse } from "./agentCallsAdminApi";
import type { AgentPhoneCallRow } from "./AgentCallsList";

export function useAgentCallRows(calls: AdminAgentPhoneCallResponse[]): AgentPhoneCallRow[] {
  return useMemo(
    () =>
      calls.map((call) => ({
        id: call.id,
        clientName: call.customer.name,
        clientId: call.customer.id,
        agentName: call.agent.name,
        date: dayjs(call.startTime).format(DATE_FORMAT),
        startTime: call.startTime,
        duration: formatCallDuration(call.length),
        isPlayable: call.isPlayable,
      })),
    [calls],
  );
}
